module.exports = __webpack_public_path__ + "static/media/eg1.6257c74a.jpg";